import { routes } from '../../constants';

const stripeSchoolAdminRoots = [
	routes.stripeSchoolAdminTeachers.root,
	routes.stripeSchoolAdminAdmins.root,
	routes.stripeSchoolAdminSubscription.root,
];

// Segment-boundary match, so a look-alike path never counts as a visit.
export const isOnStripeSchoolAdminArea = (pathname: string): boolean =>
	stripeSchoolAdminRoots.some((root) => pathname === `/${root}` || pathname.startsWith(`/${root}/`));
